module.exports = __webpack_public_path__ + "static/media/beats.04844e8b.mp4";